module.exports = __webpack_public_path__ + "static/media/person-walking.37b0676f.svg";